import React, { ReactElement, useState } from 'react';
import { DashboardCardHeading, DashboardCardLabelBlock } from './DashboardCardHeading';
import { DashboardCardBlock } from './DashboardCardContainer';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { DashboardWidgetType, Maybe } from '../../graphql/schema/p4types';
import { IWidgetItem } from './Widget';
import { makeStyles, mergeClasses } from '@fluentui/react-components';

const DashboardContent = styled.div``;

type IDashboardCardProps = {
  children: any;
  label: ReactElement | string;
  link?: Maybe<string>;
  view?: Maybe<string>;
  'data-testid'?: string;
  item?: IWidgetItem;
};

const OVERFLOW_CONTAINER_CHART_TYPES: DashboardWidgetType[] = [DashboardWidgetType.Bar, DashboardWidgetType.Analytics];

const useStyles = makeStyles({
  overflowContainer: {
    overflow: 'visible',
    zIndex: 1000000,
  },
  container: {
    flexGrow: 1,
    flexBasis: 'auto',
    maxWidth: 'none',
    textAlign: 'left',
    padding: '10px',
    overflow: 'hidden',
  },
});

const DashboardCard = ({ children, label, link = undefined, view = undefined, item, ...rest }: IDashboardCardProps) => {
  const styles = useStyles();

  const [isHovered, setIsHovered] = useState(false);
  const shouldApplyOverflowContainer = item?.type && OVERFLOW_CONTAINER_CHART_TYPES.includes(item.type) && isHovered;

  return (
    <DashboardCardBlock>
      <div
        className={mergeClasses(styles.container, shouldApplyOverflowContainer ? styles.overflowContainer : undefined)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <DashboardCardLabelBlock>
          {link ? (
            <Link to={{ pathname: link, state: { view: view } }}>
              <DashboardCardHeading data-testid={`${rest['data-testid']}-heading`}>{label}</DashboardCardHeading>
            </Link>
          ) : null}
          {label && !link ? (
            <DashboardCardHeading data-testid={`${rest['data-testid']}-heading`}>{label}</DashboardCardHeading>
          ) : null}
        </DashboardCardLabelBlock>
        <DashboardContent>{children}</DashboardContent>
      </div>
    </DashboardCardBlock>
  );
};

DashboardCard.defaultProps = {
  label: '',
};

export default DashboardCard;
